export const DEFAULT_COLOR_SEGMENT: string = '#eee';
export const MARK_COLOR_SEGMENT: string = '#e3e3e3';
